import "./CaseStudyIslandResortMaldives2RevenueGrowth.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import Performancemetrics from "./sections/Performancemetrics";
import OptimizationSolutions from "./sections/OptimizationSolutions";
import Performance from "./sections/Performance";
import ResortStrategyFaq from "./sections/ResortStrategyFaq";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudyIslandResortMaldives2RevenueGrowthPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <Performancemetrics />
      <OptimizationSolutions />
      <Performance />
      <ResortStrategyFaq />
      <Footer />
    </div>;
}